goog.provide('el8.app.settings.faxUsageAndSettings');

goog.require('el8.template.app.settings.sections');
goog.require('el8.service.urls');
goog.require('el8.util.string');


/**
 * Fax usage details
 */
el8.app.settings.faxUsageAndSettings = (function() {
    var that = {};

    that = {
        init: function($container) {
            var $content = $(el8.template.app.settings.sections.faxUsageAndSettings({
                isPracticeAdmin: el8.data.currUser.isPracticeAdmin()
            }));
            $container.html($content).show();
            _doUpdate($container);

            // Set value
            $(':input[name="defaultFaxAttachEnabled"]', $content)
                .filter('[value="'+el8Globals.FEATURES.DefaultFaxAttach+'"]')
                .prop('checked', true);


            // Bind toggle. Note: sets a practice feature flag not a setting
            $container.on('change', ':input[name="defaultFaxAttachEnabled"]',  function() {
                var $msgElt = $('.confirm-msg', $('#default-fax-attach-section'));
                if ($(this).val() === 'true') {
                    el8.data.practiceSettings.updateDefaultFaxAttachEnabled(true, function() {
                        el8.app.settings.util.handleSavedMsg($msgElt);
                    });
                } else {
                    el8.data.practiceSettings.updateDefaultFaxAttachEnabled(false, function() {
                        el8.app.settings.util.handleSavedMsg($msgElt);
                    });
                }
            });
        }
    };

    function _doUpdate($container) {
        /* Update this month's values */
        var today = el8.service.tz.today();
        var thisMonth = today.getMonth() + 1;
        var thisYear = today.getYear();

        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('getFaxUsage', [thisYear, thisMonth]),
            success: function(data) {

                var $faxCountBar = $('.fax-count-bar', $container);
                var $totalFaxVolume = $('.total-fax-volume', $container);

                $('.outbound-fax-volume', $container).text(
                    el8.util.string.formatInt(data['outbound'])
                ).removeClass('el8Loading');
                $('.inbound-fax-volume', $container).text(
                    el8.util.string.formatInt(data['inbound'])
                ).removeClass('el8Loading');
                $totalFaxVolume.text(
                    el8.util.string.formatInt(data['total'])
                ).removeClass('el8Loading');

                $('.fax-quota', $container).text(
                    el8.util.string.formatInt(data['total_quota'])
                ).removeClass('el8Loading');

                var percentQuota = Math.min(1, data['total'] / data['total_quota']) * 100;
                $faxCountBar.css('width', percentQuota + '%');
                if (percentQuota >= 100) {
                   $totalFaxVolume.addClass('el8FaxExceeded');
                   $faxCountBar.addClass('el8FaxExceeded');
                } else {
                    /* Probably never actually needed, but adding for good measure
                     * in case we end up adding a refresh button and it's possible for
                     * the quota to go up */
                   $totalFaxVolume.removeClass('el8FaxExceeded');
                   $faxCountBar.removeClass('el8FaxExceeded');
                }

            }
        });

        /* Update last month's values */
        var lastMonth = (thisMonth === 1) ? 12 : thisMonth - 1;
        var lastMonthYear = (thisMonth === 1) ? thisYear - 1 : thisYear;
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('getFaxUsage', [lastMonthYear, lastMonth]),
            success: function(data) {
                $('.last-outbound-fax-volume', $container).text(
                    el8.util.string.formatInt(data['outbound'])
                ).removeClass('el8Loading');
                $('.last-inbound-fax-volume', $container).text(
                    el8.util.string.formatInt(data['inbound'])
                ).removeClass('el8Loading');
                $('.last-total-fax-volume', $container).text(
                    el8.util.string.formatInt(data['total'])
                ).removeClass('el8Loading');
            }
        });

        /* Get inbound and outbound fax average */
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('getAverageFaxUsage', [thisYear, thisMonth]),
            success: function(data) {
                $('.inbound-fax-average', $container).text(
                    el8.util.string.formatInt(data['inbound_six_month_average'])
                ).removeClass('el8Loading');
                $('.outbound-fax-average', $container).text(
                    el8.util.string.formatInt(data['outbound_six_month_average'])
                ).removeClass('el8Loading');
                $('.total-fax-average', $container).text(
                    el8.util.string.formatInt(data['total_six_month_average'])
                ).removeClass('el8Loading');

            }
        });

    }

    return that;
})();
